import { cardRank, cardSuit, handToPbn, playState, remainingCards, } from '../core/index.js';
export function ddsTrump(strain) {
    return strain === 4 ? 4 : 3 - strain;
}
/** Pure request construction shared by the Node and browser solvers. */
export function buildSolveRequest(deal, contract, plays) {
    const state = playState(deal, contract, plays);
    const leader = state.currentTrick.length > 0 ? state.currentTrick[0].seat : state.handToPlay;
    const remaining = [0, 1, 2, 3].map((s) => remainingCards(deal, plays, s));
    const currentTrickSuit = [0, 0, 0];
    const currentTrickRank = [0, 0, 0];
    state.currentTrick.forEach((p, i) => {
        currentTrickSuit[i] = cardSuit(p.card);
        currentTrickRank[i] = cardRank(p.card) + 2;
    });
    return {
        trump: ddsTrump(contract.strain),
        first: leader,
        currentTrickSuit,
        currentTrickRank,
        remainCards: 'N:' + remaining.map((h) => handToPbn(h)).join(' '),
    };
}
export function futureTricksToDdSolve(res) {
    let bestScore = -1;
    const cardScores = new Map();
    for (let i = 0; i < res.cards; i++) {
        const suit = res.suit[i];
        const cards = [res.rank[i], ...maskToRanks(res.equals[i])].map((r) => suit * 13 + (r - 2));
        for (const card of cards)
            cardScores.set(card, res.score[i]);
        if (res.score[i] > bestScore)
            bestScore = res.score[i];
    }
    return { cardScores, bestScore };
}
/** Deterministic tie-break: lowest rank, then suit. */
export function pickFromSolve(legal, solve) {
    const best = legal
        .filter((c) => (solve.cardScores.get(c) ?? -1) === solve.bestScore)
        .sort((a, b) => cardRank(a) - cardRank(b) || cardSuit(a) - cardSuit(b));
    if (best.length === 0) {
        return legal.sort((a, b) => cardRank(a) - cardRank(b) || cardSuit(a) - cardSuit(b))[0];
    }
    return best[0];
}
function maskToRanks(mask) {
    const ranks = [];
    for (let r = 2; r <= 14; r++)
        if (mask & (1 << r))
            ranks.push(r);
    return ranks;
}
//# sourceMappingURL=play-dd.js.map